import { NavLink, useLocation } from "react-router-dom";
import "../../styles.css";
import "./Navbar.css";

export default function Navbar() {
    const location = useLocation();
    const threeDRoutes = ["/3d", "/newsletter", "/streetfood", "/flow", "/mosaic"];
    const isThreeDActive = threeDRoutes.includes(location.pathname);
    const illustrationRoutes = ["/", "/illustrations"];
    const isIllustrationsActive = illustrationRoutes.includes(location.pathname);

    return(
        <div className="tabs">
        <div className="tabs-left">
            <NavLink to="/3d" className={() => isThreeDActive ? "tab tab-active" : "tab"}>
                <h3>🎨 3D </h3>
            </NavLink>
            <NavLink to="/" className={() => isIllustrationsActive ? "tab tab-active" : "tab"}>
                <h3>🧑🏻‍🎨 Illustrations </h3>
            </NavLink>
        </div>
         <div className="tabs-right">
            <NavLink to="/about" className={({isActive}) => isActive ? "tab tab-active" : "tab"}>
                <h3>💁🏻‍♀ About </h3>
            </NavLink>
     </div>
     </div>
    )

}
